import { render, staticRenderFns } from "./parent-list-table.vue?vue&type=template&id=76d38c9a&"
import script from "./parent-list-table.vue?vue&type=script&lang=js&"
export * from "./parent-list-table.vue?vue&type=script&lang=js&"
import style0 from "./parent-list-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports